(() => {
  function init() {
    document.querySelectorAll('[data-escales-carousel]').forEach(root => {
      if (root.dataset.initialized || typeof Swiper === 'undefined') return;
      root.dataset.initialized = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const pause = root.querySelector('.anom-escales-pause');
      let manuallyPaused = false;
      let visible = false;
      const swiper = new Swiper(root.querySelector('.anom-escales-track'), {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: reduced.matches ? 0 : 500,
        autoplay: { delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true },
        navigation: { prevEl: root.querySelector('.anom-escales-prev'), nextEl: root.querySelector('.anom-escales-next') },
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { prevSlideMessage: 'Escale précédente', nextSlideMessage: 'Escale suivante' },
        breakpoints: { 700: { slidesPerView: 2 }, 1000: { slidesPerView: 3 } }
      });
      function sync() {
        const stopped = manuallyPaused || reduced.matches || !visible || document.hidden || root.matches(':hover') || root.contains(document.activeElement);
        if (stopped) swiper.autoplay.stop(); else swiper.autoplay.start();
        pause.setAttribute('aria-pressed', String(manuallyPaused || reduced.matches));
        const label = manuallyPaused ? 'Relancer le défilement' : 'Mettre le défilement en pause';
        pause.setAttribute('aria-label', label);
        pause.title = label;
        pause.firstElementChild.textContent = manuallyPaused ? '▶' : 'Ⅱ';
        pause.hidden = reduced.matches;
      }
      pause.addEventListener('click', () => { manuallyPaused = !manuallyPaused; sync(); });
      root.addEventListener('focusin', sync);
      root.addEventListener('focusout', () => requestAnimationFrame(sync));
      root.addEventListener('mouseenter', sync);
      root.addEventListener('mouseleave', sync);
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', () => { swiper.params.speed = reduced.matches ? 0 : 500; sync(); });
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(root);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
